import React from "react";
import {
	ShareDownloadsHeading,
	ShareDownloadsParagraph,
} from "@insightfulscience/atomic-react/r1/molecules/ShareDownloads";
import Line from "@insightfulscience/atomic-react/Line";
import { useLocale } from "@insightfulscience/i18";
import { subscriptionPropTypes } from "@src/propTypes/subscription";
import formatSerialNumber from "../utils/format-serial-number";

const ShareDownloadsSubscriptionInfo = ({ serialNumber }) => {
	const [t] = useLocale("share-downloads");
	const planCode = serialNumber.isBeta
		? "sg_beta_license"
		: serialNumber.isDeveloper
		? "sg_developer_license"
		: serialNumber?.plan?.planCode ?? "sg_permanent_license";
	const dateEnd = serialNumber.expirationDate ?? serialNumber.supportExpirationDate;
	return (
		<>
			<ShareDownloadsHeading>{t("DOWNLOAD_SNAPGENE")}</ShareDownloadsHeading>
			<ShareDownloadsParagraph className="mt-10 mb-0">
				{t("GROUP_NAME", {
					groupName: serialNumber.licenseName,
				})}
			</ShareDownloadsParagraph>
			<ShareDownloadsParagraph className="pb-0 my-1">
				{t("REG_CODE", {
					regCode: formatSerialNumber(serialNumber.serialNumber),
				})}
			</ShareDownloadsParagraph>
			<ShareDownloadsParagraph className="mb-10 mt-0">
				{planCode !== "sg_permanent_license"
					? t(planCode, {
							expirationDate: dateEnd,
					  })
					: ""}
			</ShareDownloadsParagraph>
			<Line spacing={{ mb: 10 }} />
		</>
	);
};

ShareDownloadsSubscriptionInfo.propTypes = {
	serialNumber: subscriptionPropTypes,
};

export default ShareDownloadsSubscriptionInfo;
